module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "avatar",
    class: [_vm.avatarSizeClass, _vm.cssClasses],
    attrs: {
      "src": _vm.imageSource,
      "width": _vm.size,
      "height": _vm.size,
      "alt": _vm.imgAlt,
      "data-container": _vm.tooltipContainer,
      "data-placement": _vm.tooltipPlacement,
      "title": _vm.tooltipText
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4a01d0"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7e4a01d0"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
// module chunks = common_vue